// extracted by mini-css-extract-plugin
export default {"light":"Logo_light__680P3","dark":"Logo_dark__l2VMP"};